import { Card, CardCover, CardTitle } from "./card";
import {
  Flex,
  Box,
  Button,
  ButtonLink,
  Paragraph,
  Text,
  SoldBadge,
} from "../../atoms";
import { IconLocation } from "../../icons";
import { Property } from "types";
import {
  getPropertyName,
  formatPropertyPricePerHa,
  styled,
  hashProperty,
} from "utils";
import { Paths } from "config/paths";

const Price = styled(Paragraph, {
  fontSize: "$4",
  fontWeight: "$extrabold",
  marginBottom: "$3",
});

const StyledCard = styled(Card, {
  width: "100%",
  maxWidth: 416,
  boxShadow: "$cards",
  "@bp3": { justifySelf: "center" },
});

const CardCoverWrapper = styled(Box, {
  position: "relative",
});

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, "property"> & {
  property: Property;
  priority?: boolean;
};

const PropertyCardWrapper = StyledCard;
const PropertyCardContent: React.FC<Props> = ({ property, priority }) => {
  const name = getPropertyName(property);
  return (
    <>
      <CardCoverWrapper>
        <CardCover src={property.images[0]} alt={name} priority={priority} />
        {property.sold ? <SoldBadge>Vendido</SoldBadge> : null}
      </CardCoverWrapper>
      <Box css={{ marginBottom: "$5" }}>
        <CardTitle css={{ marginBottom: "$2" }}>{name}</CardTitle>
        <Price>{formatPropertyPricePerHa(property)} por hectárea.</Price>
        <Flex align="start" css={{ fontWeight: "$medium", height: 32 }}>
          <Box as="span" css={{ marginRight: "$2" }}>
            <IconLocation />
          </Box>
          <Text>{property.location.access}</Text>
        </Flex>
      </Box>
      <ButtonLink href={Paths.property(hashProperty(property))}>
        <Button>Consultar</Button>
      </ButtonLink>
    </>
  );
};

const PropertyCard: React.FC<Props> = ({ property, ...props }) => {
  return (
    <PropertyCardWrapper {...props}>
      <PropertyCardContent property={property} />
    </PropertyCardWrapper>
  );
};

const PropertyGrid = styled(Box, {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyItems: "center",
  gap: "$4",
  "@bp2": {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(324px, 1fr))",
  },
});

export { PropertyCard, PropertyGrid, PropertyCardWrapper, PropertyCardContent };
